import { fetchAuthSession } from '@aws-amplify/auth';


const getUserSession = async () => {
    
    let idToken = null;

    try {
      // fetchAuthSession may throw NotAuthorizedException when the Cognito
      // Identity Pool has unauthenticated access disabled (it tries to fetch
      // AWS credentials in addition to User Pool tokens).
      // We catch that specific error and fall back to reading the cached
      // User Pool tokens directly from localStorage, where Amplify v6 stores
      // them under the key pattern:
      //   CognitoIdentityServiceProvider.<clientId>.<username>.idToken
      const session = await fetchAuthSession({ forceRefresh: false });
      idToken = session?.tokens?.idToken?.toString() ?? null;
    } catch (error) {
      // fetchAuthSession can fail when the Cognito Identity Pool is misconfigured
      // or absent (e.g. production environments without an Identity Pool).
      // In all error cases, fall back to reading the cached User Pool idToken
      // directly from localStorage where Amplify v6 stores it.
      console.warn('fetchAuthSession failed, falling back to localStorage token:', error?.message);
      try {
        idToken = getIdTokenFromLocalStorage();
      } catch (fallbackError) {
        console.error('Fallback token read failed:', fallbackError);
      }
    }

    return idToken; // Or use it for other purposes
  };

/**
 * Reads the Cognito idToken directly from Amplify's localStorage cache.
 * Amplify v6 stores tokens under:
 *   CognitoIdentityServiceProvider.<clientId>.<username>.idToken
 * The last-authenticated user key is:
 *   CognitoIdentityServiceProvider.<clientId>.LastAuthUser
 */
const getIdTokenFromLocalStorage = () => {
  // Scan localStorage for the LastAuthUser key to find the client ID and username
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.endsWith('.LastAuthUser')) {
      const username = localStorage.getItem(key);
      if (username) {
        // Derive the idToken key from the LastAuthUser key
        const prefix = key.replace('.LastAuthUser', '');
        const idTokenKey = `${prefix}.${username}.idToken`;
        const token = localStorage.getItem(idTokenKey);
        if (token) return token;
      }
    }
  }
  return null;
};


export { getUserSession };
